export default "__VITE_ASSET__7ddabdef__"